
<div class="cordova-wrapper">
  <ion-spinner name="lines-sharp-small"></ion-spinner>
</div>